<template>
  <div class="info">
<!--    <img class="info__bg" src="@images/infoBg.png" alt="bg">-->
    <div class="container">
      <div class="info__wrapper">
        <div class="info__right">
          <router-link :to="translations.i18nRoute({ name: 'market', query: { categoriesSlugs: 'games' }})">
            <img src="@images/infoImage.png" alt="image">
          </router-link>
          <router-link :to="translations.i18nRoute({ name: 'market', query: { categoriesSlugs: 'games' }})">
            <img src="@images/infoImage2.png" alt="image">
          </router-link>
        </div>
        <div class="info__left">
<!--          <h2>{{ t('home.info.title') }}</h2>-->
          <p>
            <span>{{ t('home.info.text1') }}</span>
<!--            <span>{{ t('home.info.text2') }}</span>-->
          </p>
          <router-link class="info__button" :to="translations.i18nRoute({ name: 'market' })">
            {{ t('buttons.startShopping') }}
            <svg xmlns="http://www.w3.org/2000/svg" width="27" height="28" viewBox="0 0 27 28" fill="none">
              <path d="M9.5625 6.125L17.4375 14L9.5625 21.875" stroke="#01AC1B" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import translations from "@/core/helpers/translations.js";

const {t} = useI18n()
</script>

<style lang="scss" scoped>
.info {
  padding-top: 150px;
  position: relative;

  &__bg {
    position: absolute;
    bottom: 0;
    right: 0;
  }

  &__wrapper {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    gap: 175px;
  }

  &__left {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 20px;

    & h2 {
      color: #013F0B;
      font-size: 63px;
      font-weight: 700;
      line-height: 63px;
    }

    & p {
      display: flex;
      flex-direction: column;
      gap: 15px;

      & span {
        color: #7B9980;
        text-align: justify;
        font-size: 22px;
        font-weight: 600;
        line-height: 27px;
      }
    }
  }

  &__button {
    cursor: pointer;
    width: fit-content;
    border-radius: 27px;
    background-color: #F3F9FB;
    box-shadow: 0 4px 7.3px 0 rgba(0, 0, 0, 0.50);
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 10px 20px;
    transition: 0.2s;

    color: #222;
    font-size: 20px;
    font-weight: 500;
    line-height: 27px;

    @include hover {
      background-color: #bebebe;
    }
  }

  &__right {
    position: relative;
    display: flex;
    align-items: stretch;
    gap: 25px;

    & img {
      width: 225px;
      object-fit: cover;
      border-radius: 10px;
    }
  }
}

@media (max-width: 1300px) {
  .info {
    &__wrapper {
      flex-direction: column;
      align-items: center;
      gap: 75px;
    }

    &__left {
      gap: 25px;
      align-items: center;

      & h2 {
        font-size: 48px;
      }

      & p span {
        text-align: center;
      }
    }

    &__right {
      & img {
        width: 200px;
      }
    }
  }
}

@media (max-width: 1000px) {
  .info {
    &__wrapper {
      flex-direction: column;
    }
  }
}

@media (max-width: 500px) {
  .info {
    &__wrapper {
      gap: 30px;
    }

    &__left {
      & h2 {
        font-size: 32px;
      }

      & p span {
        font-size: 18px;
      }
    }

    &__right {
      & img {
        width: 100%;
      }

      & a {
        left: 15px;
        bottom: 15px;
      }
    }
  }
}
</style>